import React from 'react';
import SEO from "../common/SEO";
import {Link} from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import HeaderOne from '../common/header/HeaderOne';
import HeaderTopBar from '../common/header/HeaderTopBar';
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import AboutEnvironmental from '../elements/about/AboutEnvironmental';
import Separator from "../elements/separator/Separator";






const EnvironmentalPolicy = () => {
    return (
        <>
            <SEO title="EnvironmentalPolicy" />
            <main id="main-content" className="page-wrapper" aria-label="Main content">
                <HeaderTopBar />
                <HeaderOne btnStyle="round" HeaderSTyle="header-not-transparent" />

               
                <Separator />

                {/* Start About Area  */}
                <AboutEnvironmental/>                            
                {/* End About Area  */}

                

                <Separator />   
               
                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default EnvironmentalPolicy;
